<template>
  <div>


    <b-card no-body>
      <b-tabs card>
        <b-tab title="基本資料" active>
          <b-card-text>
            <div class="form-group row">
              <label for="" class="col-sm-2">姓名(App註冊)</label>
              <div class="col-sm-10">
                <label for="" class="col-sm-2">{{ dataUser.name }}</label>
              </div>
            </div>
            <div class="form-group row">
              <label for="" class="col-sm-2">別名</label>
              <div class="col-sm-2">
                <input type="text" class="form-control" v-model="dataUser.alias">
                <span class="input-group-append">
                  <a class="btn btn-primary" href="#" @click="saveData_user()" ><i class="fa fa-save"></i> 儲存</a>
                </span>
              </div>
            </div>
            <div class="form-group row">
              <label for="" class="col-sm-2">登入帳號(手機)</label>
              <div class="col-sm-10">
                <label for="" class="col-sm-2">{{ dataUser.email }}</label>
              </div>
            </div>
            <div class="form-group row">
              <label for="" class="col-sm-2">縣市</label>
              <div class="input-group col-sm-3">
<!--                <label for="" class="col-sm-2">{{ dataUser.area }}</label>-->
                <select class="form-control" placeholder="請選擇 居地住" name="area" type="text" v-model="dataUser.area" >
                  <option value=""></option>
                  <option value="臺北市">臺北市</option>
                  <option value="新北市">新北市</option>
                  <option value="桃園市">桃園市</option>
                  <option value="臺中市">臺中市</option>
                  <option value="臺南市">臺南市</option>
                  <option value="高雄市">高雄市</option>
                  <option value="基隆市">基隆市</option>
                  <option value="新竹縣">新竹縣</option>
                  <option value="新竹市">新竹市</option>
                  <option value="苗栗縣">苗栗縣</option>
                  <option value="南投縣">南投縣</option>
                  <option value="彰化縣">彰化縣</option>
                  <option value="雲林縣">雲林縣</option>
                  <option value="嘉義縣">嘉義縣</option>
                  <option value="嘉義市">嘉義市</option>
                  <option value="屏東縣">屏東縣</option>
                  <option value="宜蘭縣">宜蘭縣</option>
                  <option value="花蓮縣">花蓮縣</option>
                  <option value="臺東縣">臺東縣</option>
                  <option value="澎湖縣">澎湖縣</option>
                  <option value="金門縣">金門縣</option>
                  <option value="連江縣">連江縣</option>
                  <option value="其他">其他</option>
                </select>

                <div class="input-group-append">
                  <a class="btn btn-primary" href="#" @click="saveData_user()" ><i class="fa fa-save"></i> 儲存</a>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label for="" class="col-sm-2">註冊日</label>
              <div class="col-sm-10">
                <label for="" class="col-sm-2">{{ dataUser.created_at }}</label>
              </div>
            </div>
          </b-card-text>
        </b-tab>
        <b-tab title="等級及建議">
          <b-card-text>
            <AppContentQuestionMemberSuggest :user-id="id" :data="dataSuggest" :dataProfile="dataUserProfile"></AppContentQuestionMemberSuggest>
          </b-card-text>
        </b-tab>
        <b-tab title="風險評估結果">
          <b-card-text>
            <AppContentQuestionMemberAnswered :datas="dataQuestionAnswereds"></AppContentQuestionMemberAnswered>
          </b-card-text>
        </b-tab>
        <b-tab title="互動記錄">
          <b-card-text>
            <ListDataEditOneRecord ref="caseLog" :user-id="id"></ListDataEditOneRecord>
          </b-card-text>
        </b-tab>
        <b-tab title="個案備註" >
          <b-card-text>
            <a class="btn btn-primary" href="#" @click="saveData_case()"><i class="fa fa-save"></i> 儲存</a>

            <table class="table table-hover" style="width:400px">
              <thead class="thead-light">
              <tr>
                <th>標籤1</th>
                <th>標籤2</th>
                <th>標籤3</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td class="text-left">
                  <input type="text" class="form-control"  placeholder="" v-model="dataCaseMag.tag1">
                </td>
                <td class="text-left">
                  <input type="text" class="form-control"  placeholder="" v-model="dataCaseMag.tag2">
                </td>
                <td class="text-left">
                  <input type="text" class="form-control"  placeholder="" v-model="dataCaseMag.tag3">
                </td>
              </tr>

              </tbody>
            </table>
            <textarea class="form-control" id="txtMemo" name="txtMemo" rows="20"  v-model="dataCaseMag.content"></textarea>
          </b-card-text>
        </b-tab>
<!--        <b-tab title="簡歷" >-->
<!--          <b-card-text>-->
<!--&lt;!&ndash;            <ListDataCurd :datas="this.datasMemo"></ListDataCurd>&ndash;&gt;-->
<!--          </b-card-text>-->
<!--        </b-tab>-->
        <b-tab title="訊息" >
          <b-card-text>
            發送推播訊息(給此傷友)
            <input type="text" class="form-control" id="name" name="name" placeholder="">
            <button class="btn btn-primary" >發送</button>
            <ListData></ListData>
          </b-card-text>
        </b-tab>
        <b-tab title="檔案" >
          <b-card-text>
            <a class="btn btn-primary" href="#" @click="saveData_files()"><i class="fa fa-save"></i> 儲存</a>
            <ListEditFile :datas="dataFiles" :allow-single-file="false"></ListEditFile>
          </b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import AppContentQuestionMemberAnswered from "./AppContentQuestionMemberAnswered";
import AppContentQuestionMemberSuggest from "./AppContentQuestionMemberSuggest";
import apiTzsci from "@/views/tzsci/js/apiTzsci";
import util from "@/util/util";
import ListData from "@/views/tzsci/component/ListData";
import ListDataEditOneRecord from "@/views/tzsci/component/ListDataEditOneRecord";
import ListEditFile from "@/views/tzsci/component/ListEditFile.vue";
import apiAdmin from "@/views/taylorAdmin/js/apiAdmin";
/**

 **/


export default {
  components: {
    ListEditFile,
    ListDataEditOneRecord, ListData,  AppContentQuestionMemberSuggest, AppContentQuestionMemberAnswered},
  //name: "member",
  // props: [""],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      // datasInteraction:[
      //   {
      //     date:"111-01-1",
      //     desc:"協助住院",
      //   },
      //   {
      //     date:"111-01-2",
      //     desc:"住院訪視: xxxxx",
      //   },
      // ],
      // datasMemo:[
      //   {
      //     date:"111-01-1",
      //     desc:"聯絡請其回診",
      //   },
      //   {
      //     date:"111-01-1",
      //     desc:"聯絡請其回診",
      //   },
      // ],
      dataUser:{},
      dataUserProfile:{},
      dataSuggest:{},
      dataQuestionAnswereds:[],
      dataCaseMag:{},
      // dataCaseMagLogs:[],
      dataMedHistory:{},
      dataMsgLogs:[],
      dataFiles:[],
    };
  },
  methods: {
    async loadData() {
      let loader=await util.ShowLoading(this);

      this.dataUser=await apiTzsci.api_Admin_GetUser(this.id);
      this.dataUserProfile=await apiTzsci.api_Admin_GetUserProfile(this.id);
      if (!this.dataUserProfile) this.dataUserProfile={};

      this.dataSuggest=await apiTzsci.api_Admin_GetSuggest(this.id);
      if (!this.dataSuggest) this.dataSuggest={};

      this.dataQuestionAnswereds=await apiTzsci.api_Admin_GetQuestionAnswered(this.id);
      if (!this.dataQuestionAnswereds) this.dataQuestionAnswereds={};

      this.dataCaseMag=await apiTzsci.api_Admin_GetCase(this.id);
      if (!this.dataCaseMag) this.dataCaseMag={};

      this.dataFiles=await apiTzsci.api_Admin_GetUserFiles(this.id);
      if (!this.dataFiles) this.dataFiles=[];

      // this.dataCaseMagLogs=await apiTzsci.api_Admin_GetCaseLog(this.id);

      this.$refs.caseLog.loadData();

      await util.HideLoading(loader);
      // debugger // eslint-disable-line
      // this.dataMedHistory=await apiTzsci.api_Admin_GetMedHistory(this.id);
      // this.dataMsgLogs=await apiTzsci.api_Admin_GetMsgLog(this.id);
    },
    async saveData_case(){
      await apiTzsci.api_Admin_UpdateCase(this.id,this.dataCaseMag.tag1,this.dataCaseMag.tag2,this.dataCaseMag.tag3,this.dataCaseMag.content,"");
      await util.ShowMessage('儲存成功')
    },

    async saveData_user(){
      await apiTzsci.api_Admin_UpdateUser(this.id,this.dataUser.area,this.dataUser.alias);
      await util.ShowMessage('儲存成功')
    },
    async saveData_files(){
      await apiTzsci.api_Admin_UpdateUserFiles(this.id,this.dataFiles);
      await util.ShowMessage('儲存成功')
    }
  },
  mounted() {
    this.id=this.$route.query.id
    this.loadData()
  },
}
</script>

<style scoped>

</style>
